var OrganizationsContent;

import Actions from './actions.js';

export default OrganizationsContent = Vue.extend({
  components: {
    'actions': Actions
  },
  props: {
    actionOptions: {
      type: Array
    },
    bindedMembersCount: {
      type: Number,
      required: true
    },
    membersCount: {
      type: Number,
      required: true
    },
    selectedRows: {
      type: Array
    },
    refreshDataAfterOperation: {
      type: Function
    },
    organization: {
      type: Object
    },
    profileSchema: {
      type: Object
    }
  },
  data: function() {
    return {
      memberCounterFetching: true
    };
  },
  template: `<div class="datable-table-summary justify-between">
  <actions :options='actionOptions'
           :selectedRows="selectedRows"
           :profileSchema="profileSchema"
           :refreshDataAfterOperation='refreshDataAfterOperation'
           :organization='organization'
           @refreshSeletedRowsTags='refreshSeletedRowsTags'>
  </actions>
  <div class="vertical-middle light-gray-text">
    <span>共 {{ membersCount }} 人/绑定 {{ bindedMembersCount }} 人</span>
  </div>
</div>`,
  methods: {
    refreshSeletedRowsTags: function(updateTagsOptions) {
      return this.$emit("refreshSeletedRowsTags", updateTagsOptions);
    }
  }
});
